import { render, staticRenderFns } from "./DoctorTableComponent.vue?vue&type=template&id=f5bd0a9c"
import script from "./DoctorTableComponent.vue?vue&type=script&lang=js"
export * from "./DoctorTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports